import React from "react";
import { connect } from "react-redux";

import { logout } from "../../../../actions/authentication/authentication";

import MenuItem from "../MenuItems/MenuItem";
import MenuItemLogo from "../MenuItems/MenuItemLogo";

import "./menu.css";
import { Button, Nav, Navbar } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

/**
 * Menu (navbar)
 * @param {Array} menuItems list of all informations for items menu
 * @param {Array} menuItemLogo list of informations for logo item menu
 */
class Menu extends React.Component {
  logout(e) {
    e.preventDefault();
    e.stopPropagation();

    // let that = this;

    function onLogoutSuccess() {
      // that.props.history.push('/');
      return window.location.replace("/");
    }

    // Call logout and redirect on success
    this.props.onLogout(onLogoutSuccess);
  }

  render() {
    const { menuItems, menuItemLogo } = this.props;

    const menuItemNode = (items) => {
      return items.map((item, index) => {
        return (
          <div key={index} className="m-1">
            <MenuItem
              link={item.link}
              event={item.event}
              formattedMessageId={item.formattedMessageId}
            />
          </div>
        );
      });
    };

    return (
      <React.Fragment>
        <Navbar collapseOnSelect expand="lg" className="navbar menu">
          <MenuItemLogo
            link={"/#"}
            imgSrc={menuItemLogo.imgSrc}
            imgAlt={menuItemLogo.imgAlt}
            onClick={null}
          />

          <Navbar.Toggle aria-controls="menu" />

          <Navbar.Collapse id="menu" className="mb-3 mb-md-0 mt-2 pb-2">
            <Nav className="align-items-center">{menuItemNode(menuItems)}</Nav>
          </Navbar.Collapse>

          <Button
            variant="danger"
            className="ml-auto"
            onClick={(e) => this.logout(e)}
          >
            <FormattedMessage id="Logout" />
          </Button>
        </Navbar>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: (successCallback) => dispatch(logout(successCallback)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
